import Icon from '../components/Icon.vue'

Icon.register({
  'x-ray': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M240 384C231.2 384 224 391.2 224 400S231.2 416 240 416 256 408.8 256 400 248.8 384 240 384zM400 416C408.8 416 416 408.8 416 400S408.8 384 400 384 384 391.2 384 400 391.2 416 400 416zM624 0H16C7.2 0 0 7.2 0 16V48C0 56.8 7.2 64 16 64H624C632.8 64 640 56.8 640 48V16C640 7.2 632.8 0 624 0zM624 448H576V96H64V448H16C7.2 448 0 455.2 0 464V496C0 504.8 7.2 512 16 512H624C632.8 512 640 504.8 640 496V464C640 455.2 632.8 448 624 448zM480 248C480 252.4 476.4 256 472 256H336V288H440C444.4 288 448 291.6 448 296V312C448 316.4 444.4 320 440 320H336V352H400C426.5 352 448 373.5 448 400S426.5 448 400 448 352 426.5 352 400V384H288V400C288 426.5 266.5 448 240 448S192 426.5 192 400 213.5 352 240 352H304V320H200C195.6 320 192 316.4 192 312V296C192 291.6 195.6 288 200 288H304V256H168C163.6 256 160 252.4 160 248V232C160 227.6 163.6 224 168 224H304V192H200C195.6 192 192 188.4 192 184V168C192 163.6 195.6 160 200 160H304V136C304 131.6 307.6 128 312 128H328C332.4 128 336 131.6 336 136V160H440C444.4 160 448 163.6 448 168V184C448 188.4 444.4 192 440 192H336V224H472C476.4 224 480 227.6 480 232V248z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/x-ray.js
// module id = VgDY
// module chunks = 144